import { LocationStringMap } from '../../../util/index';
import { Http, Resource } from '../../models/index';
import { UseCase } from '../UseCase';
import { RequestResource } from './RequestResource';

export namespace PostResource {
    export interface Params<L extends string, T> {
        parent: Resource<L>;
        rel: L;
        body?: T;
        noLinkError?: boolean;
        queryParams?: object;
        search?: LocationStringMap;
    }
}

export class PostResource<L extends string, T, V>
    implements UseCase<PostResource.Params<L, T>, Promise<V | undefined>>
{
    private requestResource: RequestResource<L, T, V>;

    constructor(http: Http) {
        this.requestResource = new RequestResource<L, T, V>(http);
    }

    execute(params: PostResource.Params<L, T>): Promise<V | undefined> {
        return this.requestResource.execute({
            method: 'POST',
            parent: params.parent,
            rel: params.rel,
            body: params.body,
            search: params.search,
            noLinkError: params.noLinkError,
            queryParams: params.queryParams
        });
    }
}
